
import { Button, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTablePagination from "../../components/Table/DataTablePagination.jsx";
import { getAllOrderedService, getAllServicesService, getQcServices } from "../../services/servicesServices.js";
import EmailAndPhone from "../Users/additionFields/EmailAndPhone.jsx";
import Actions from "./additionFields/Actions.jsx";
import ServiceImage from "./additionFields/ServiceImage.jsx";
import ConstructionStatus from "./additionFields/ConstructionStatus.jsx";
import Contractor from "./additionFields/Contractor.jsx";
import Payment from "./additionFields/Payment.jsx";
import { convertDateToJalaali } from "../../utils/convertDate.js";
import { base_api_url } from "../../services/httpService.js";
import { DownloadRounded, QuestionAnswer } from "@mui/icons-material";
import { fileDownloaderWithName, fileDownloaderWithoutFormat } from "../../utils/fileDownloader.js";
import ReceiveService from "./additionFields/ReceiveService.jsx";
import QualityControlRecord from "./additionFields/QualityControlRecord.jsx";
import ManagerDetail from "./additionFields/ManagerDetail.jsx";

const options = [
  {
    text: "همه سرویس ها",
    value: "",
  },
  {
    text: "کنترل نشده",
    value: "c",
  },
  {
    text: "کنترل شده",
    value: "r",
  }
];

const QualityControlPage = () => {
  const [forceRequest, setForceRequest] = useState(0);

  const navigate = useNavigate();

  const servicesCols = [
    {
      field: "code",
      text: "کد سرویس",
    },
    {
      field: null,
      text: "تصویر",
      element: (rowData) => (
        <ServiceImage rowData={rowData} scrollQuery="#div-content" />
      ),
    },
    {
      field: null,
      text: "وضعیت",
      element: (rowData) => <ConstructionStatus rowData={rowData} />,
    },
    {
      field: null,
      text: "پیمانکار",
      element: (rowData) => <Contractor rowData={rowData} />,
    },
    {
      field: null,
      text: "مبلغ (تومان)",
      element: (rowData) => <Payment rowData={rowData} access={"manager"} />,
    },
    {
      field: null,
      text: "تاریخ تحویل",
      element: (rowData) => <span>{convertDateToJalaali(rowData.preparation_date)}</span>,
    },
    {
      field: null,
      text: "جزییات",
      element: (rowData) => {
        return (
          <Button
            variant="contained"
            onClick={() =>
              window.open(
                `http://app.wisercam.com/DetailOrder/${rowData.code}`
              )
            }
          >
            مشاهده
          </Button>
        );
      },
    },
    {
      field: null,
      text: "فایل مشتری",
      element: (rowData) => {
        return (
            <Button
                variant="contained"
                onClick={() => 
                    {
                        fileDownloaderWithName(`${base_api_url}/shop_admin/get_customer_file/${rowData.code}/`, null, false);
                    }}
            >
                <span className="ms-1">
                    <DownloadRounded />
                </span>
            </Button>
        );
      },
    },
    {
      field: null,
      text: "فایل نقشه",
      element: (rowData) => {
        return (
            <Button
                variant="contained"
                onClick={() => 
                    {
                        fileDownloaderWithoutFormat(`${base_api_url}/shop_admin/get_local_customer_file/${rowData.code}/`)
                    }}
            >
                <span className="ms-1">
                    <DownloadRounded />
                </span>
            </Button>
        );
      },
    },
    {
      field: null,
      text: "توضیحات",
      element: (rowData) =>  <ManagerDetail rowData={rowData} iO={"q"} />
    },
    {
      field: null,
      text: "عملیات",
      element: (rowData) =>  <QualityControlRecord rowData={rowData} />
    },
  ];

  return (
    <DataTablePagination
      tableCols={servicesCols}
      title={"کنترل کیفیت"}
      APIFunction={getQcServices}
      dataField={"services"}
      hasOutlet={true}
      hasCatergory={true}
      categoryOptions={options}
      forceRequest={forceRequest}
      setForceRequest={setForceRequest}
    ></DataTablePagination>
  );
};

export default QualityControlPage;
